import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Form, Select, DatePicker, Radio, Button } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import ReactECharts from 'echarts-for-react';
import calc from '../calc.js';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';


const pvOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(pvOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const batOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(batOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const acOption = {
    tooltip: {
        trigger: 'axis'
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(acOption);
                }
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const epsOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(epsOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}


function RuntimeParameter(props) {
    const { t } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, protocol, handleSelectSN } = props
    const [invData, setInvData] = useState(null)  //逆变器数据
    const setTip = useContext(utils.tipContext)

    const [parameterDate, setParameterDate] = useState(moment().format('YYYY-MM-DD')) //时间

    const [activePV, setActivePV] = useState(0)
    const [activeBat, setActiveBat] = useState(0)
    const [activeAC, setActiveAC] = useState(0)
    const [activeEps, setActiveEps] = useState(0)
    const [PVTitle, setPVTitle] = useState(t('Vpv1(V)'))
    const [BatTitle, setBatTitle] = useState(t('SOC(%)'))
    const [ACTitle, setACTitle] = useState(t('Vacr(V)'))
    const [EpsTitle, setEpsTitle] = useState(t('Vepsr(V)'))

    const pvChart = useRef(null)
    const batChart = useRef(null)
    const acChart = useRef(null)
    const epsChart = useRef(null)

    //2025.1.15
    let hasSmartPlug = false
    if (protocol == "Sungery" && invData) {
        if (invData.OnGirdSet == 5) {
            hasSmartPlug = true;
        }
    }
    
    useEffect(() => {
        pvOption.series[0].markLine.data[0].name = t("Avg")
        pvOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
        batOption.series[0].markLine.data[0].name = t("Avg")
        batOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
        acOption.series[0].markLine.data[0].name = t("Avg")
        acOption.series[0].markLine.label.formatter = `Avg: {c}`;
        epsOption.series[0].markLine.data[0].name = t("Avg")
        epsOption.series[0].markLine.label.formatter = `Avg: {c}`;
    }, [t])

    //pvOption
    const exportToExcel_PV =  useCallback(() => {
        if (pvOption.series[0].data == null || pvOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activePV == 0 ? t('Vpv1') :
            activePV == 1 ? t('Vpv2') :
            activePV == 2 ? t('Vpv3') :
            activePV == 3 ? t('Vpv4') :
            activePV == 4 ? t('Ppv1') :
            activePV == 5 ? t('Ppv2') :
            activePV == 6 ? t('Ppv3') :
            activePV == 7 ? t('Ppv4') :
            "";

        let rs = 
        pvOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = pvOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_PV_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activePV,  t]);
    pvOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_PV;

    //batOption
    const exportToExcel_Bat =  useCallback(() => {
        if (batOption.series[0].data == null || batOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeBat == 0 ? t('SOC(%)') :
            activeBat == 1 ? t('Vbat') :
            activeBat == 2 ? t('Ibat') :
            activeBat == 3 ? t('Pcharge') :
            activeBat == 4 ? t('Pdischarge') :
            "";

        let rs = 
        batOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = batOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_Battery_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeBat,  t]);
    batOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_Bat;

    //acOption
    const exportToExcel_AC =  useCallback(() => {
        if (acOption.series[0].data == null || acOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeAC == 0 ? t('Vacr') :
            activeAC == 1 ? t('Qac') :
            activeAC == 2 ? t('PToGrid') :
            activeAC == 3 ? t('PFromGrid') :"";

        let rs = 
        acOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = acOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_AC_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeAC,  t]);
    acOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_AC;

    //epsOption
    const exportToExcel_Eps =  useCallback(() => {
        if (epsOption.series[0].data == null || epsOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeEps == 0 ? t('Vepsr') :
            activeEps == 1 ? t('Feps') :
            activeEps == 2 ? t('Peps') :
            activeEps == 3 ? t('Seps') :
            "";

        let rs = 
        epsOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = epsOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_Eps_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeEps,  t]);
    epsOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_Eps;

    //获取日数据
    useEffect(() => {
        if (!SN) return;
        let active = true;
        (async () => {
            let resp = await http.post("integrated-inverter/report/daily/report", {
                SerialNumber: SN,
                Date: parameterDate,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {  //请求日数据失败
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
                return;
            } else {
                //对Sungery阳台经济的特殊处理
                if (protocol === 'Sungery') {
                    const IBat = calc.current(resp.data.IBat, protocol)
                    const VBat = calc.voltage(resp.data.VBat, protocol)
                    resp.data.PBat = IBat * VBat;
                    //根据OnGridSet的值(1-无CT, 2-有CT)来决定负载功率是否为0 
                    //OnGridSet=1(无CT): 负载功率置0，电网功率=市电有功功率(LinePowerW_A)
                    //OnGridSet=2(有CT)：负载功率=NormalLoadW_A，电网功率=电网测有功功率(GridPowerW_A)
                    let resp2 = await http.post("integrated-inverter/setting/field/get", { SerialNumber: SN, Addr: 'A034' }).then(async (r) => {
                        return await r.json();
                    }).catch((e) => {
                        return null;
                    });
                    if (resp2 && resp2.data == 1) { //无CT
                        resp.data.PAC1LOAD = 0;
                        resp.data.PAC2LOAD = 0;
                        resp.data.PAC3LOAD = 0;
                        resp.data.PAC1GRID = resp.data.PAC1Line;
                        resp.data.PAC2GRID = resp.data.PAC2Line;
                        resp.data.PAC3GRID = resp.data.PAC3Line;
                    }
                    resp.data.VAC1GRID = resp.data.VAC1Line;
                    resp.data.VAC2GRID = resp.data.VAC2Line;
                    resp.data.VAC3GRID = resp.data.VAC3Line;
                    resp.data.FACGRID = resp.data.FACLine;
                }
                setInvData(resp.data)
            }
        })();

        return () => {
            active = false;
        };

    }, [SN, parameterDate, t]);

    //draw PV Chart
    useEffect(() => {
        if (!invData) {
            pvOption.xAxis.data = []
            pvOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                xData.push(moment(v['YMDH']).format('YYYY-MM-DD HH:mm'))
                yData.push(activePV == 0 ? calc.voltage(v['VMPPT1'], protocol) :
                    activePV == 1 ? calc.voltage(v['VMPPT2'], protocol) :
                        activePV == 2 ? calc.voltage(v['VMPPT3'], protocol) :
                            activePV == 3 ? calc.voltage(v['VMPPT4'], protocol) :
                                activePV == 4 ? calc.power(protocol === 'Senergy' ? v['PDC'] : v['PMPPT1'], protocol) :
                                    activePV == 5 ? calc.power(v['PMPPT2'], protocol) :
                                        activePV == 6 ? calc.power(v['PMPPT3'], protocol) :
                                            activePV == 7 ? calc.power(v['PMPPT4'], protocol) :
                                                null)
            })
            //x轴坐标
            pvOption.xAxis.data = xData;
            //数据
            pvOption.series[0] =
                activePV == 0 ? { ...pvOption.series[0], name: t('Vpv1'), data: yData } :
                    activePV == 1 ? { ...pvOption.series[0], name: t('Vpv2'), data: yData } :
                        activePV == 2 ? { ...pvOption.series[0], name: t('Vpv3'), data: yData } :
                            activePV == 3 ? { ...pvOption.series[0], name: t('Vpv4'), data: yData } :
                                activePV == 4 ? { ...pvOption.series[0], name: t('Ppv1'), data: yData } :
                                    activePV == 5 ? { ...pvOption.series[0], name: t('Ppv2'), data: yData } :
                                        activePV == 6 ? { ...pvOption.series[0], name: t('Ppv3'), data: yData } :
                                            activePV == 7 ? { ...pvOption.series[0], name: t('Ppv4'), data: yData } :
                                                null
        }
        const instance = pvChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(pvOption, true);
        }
    }, [invData, activePV, t])

    //draw Battery Chart
    useEffect(() => {
        if (!invData) {
            batOption.xAxis.data = []
            batOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                let powerCharge = 0
                let powerDischarge = 0
                if (protocol === 'Sungery') {
                    v['PBat'] = calc.current(v['IBat'], protocol) * calc.voltage(v['VBat'], protocol)
                }
                if (protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS') {
                    v['PBat'] = calc.convertComplement(v['PBat'], protocol)
                    powerCharge = calc.power(v['PBat'] > 0 ? v['PBat'] : 0, protocol)
                    powerDischarge = calc.power(v['PBat'] < 0 ? Math.abs(v['PBat']) : 0, protocol)
                } else {
                    powerCharge = calc.power(v['PBat'] < 0 ? Math.abs(v['PBat']) : 0, protocol)
                    powerDischarge = calc.power(v['PBat'] > 0 ? v['PBat'] : 0, protocol)
                }
                xData.push(moment(v['YMDH']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeBat == 0 ? calc.soc(v['SOC'], protocol) :
                    activeBat == 1 ? calc.voltage(v['VBat'], protocol) :
                        activeBat == 2 ? calc.current(v['IBat'], protocol) :
                            activeBat == 3 ? powerCharge :
                                activeBat == 4 ? powerDischarge :
                                    null)
            })
            //x轴坐标
            batOption.xAxis.data = xData;
            //数据
            batOption.series[0] =
                activeBat == 0 ? { ...batOption.series[0], name: t('SOC'), data: yData } :
                    activeBat == 1 ? { ...batOption.series[0], name: t('VBat'), data: yData } :
                        activeBat == 2 ? { ...batOption.series[0], name: t('IBat'), data: yData } :
                            activeBat == 3 ? { ...batOption.series[0], name: t('Charge Power'), data: yData } :
                                activeBat == 4 ? { ...batOption.series[0], name: t('Discharge Power'), data: yData } :
                                    null
        }

        const instance = batChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(batOption, true);
        }
    }, [invData, activeBat, t])

    //draw AC Chart
    useEffect(() => {
        if (!invData) {
            acOption.xAxis.data = []
            acOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                let PACGRID = 0
                let powerToGrid = 0
                let powerFromGrid = 0
                v['PAC1GRID'] = calc.convertComplement(v['PAC1GRID'], protocol)
                v['PAC2GRID'] = calc.convertComplement(v['PAC2GRID'], protocol)
                v['PAC3GRID'] = calc.convertComplement(v['PAC3GRID'], protocol)
                if (protocol === 'Megarevo' || protocol === 'Thinkpower' || protocol === 'Megarevo-CESS') {
                    PACGRID = v['PAC1GRID'] + v['PAC2GRID'] + v['PAC3GRID']
                    powerToGrid = PACGRID > 0 ? calc.power(PACGRID, protocol) : 0
                    powerFromGrid = PACGRID < 0 ? calc.power(Math.abs(PACGRID), protocol) : 0
                } else {
                    PACGRID = v['PAC1GRID'] + v['PAC2GRID'] + v['PAC3GRID']
                    powerToGrid = PACGRID < 0 ? calc.power(Math.abs(PACGRID), protocol) : 0
                    powerFromGrid = PACGRID > 0 ? calc.power(PACGRID, protocol) : 0
                }
                if (hasSmartPlug == true && invData) { //有智能插座 2025.1.16
                    let PAC1Inv = parseInt(invData.PAC1Inv)??0;
                    let PAC1LOAD = parseInt(invData.PAC1LOAD)??0;
                    let PAC1EPS = parseInt(invData.PAC1EPS)??0;
                    PAC1Inv = calc.convertComplement(PAC1Inv, protocol)
                    PAC1LOAD = calc.convertComplement(PAC1LOAD, protocol)
                    PAC1EPS = calc.convertComplement(PAC1EPS, protocol)
                    powerToGrid = PAC1LOAD - PAC1Inv + PAC1EPS;
                    if (PAC1Inv > 0 && powerToGrid < 0) {
                        powerFromGrid = Math.abs(powerToGrid);
                        powerToGrid = 0 ;
                    } else {
                        powerFromGrid = 0;
                    }
                } 
                xData.push(moment(v['YMDH']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeAC == 0 ? calc.voltage(v['VAC1GRID'], protocol) :
                    activeAC == 1 ? calc.energy(v['EDayToGRID'], protocol) :
                        activeAC == 2 ? powerToGrid :
                            activeAC == 3 ? powerFromGrid :
                                null)
            })
            //x轴坐标
            acOption.xAxis.data = xData
            //数据
            acOption.series[0] =
                activeAC == 0 ? { ...acOption.series[0], name: t('Vacr'), data: yData } :
                    activeAC == 1 ? { ...acOption.series[0], name: t('Qac'), data: yData } :
                        activeAC == 2 ? { ...acOption.series[0], name: t('PToGrid'), data: yData } :
                            activeAC == 3 ? { ...acOption.series[0], name: t('PFromGrid'), data: yData } :
                                null
        }

        const instance = acChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(acOption, true);
        }
    }, [invData, activeAC, t])

    //draw Eps Chart
    useEffect(() => {
        if (!invData) {
            epsOption.xAxis.data = []
            epsOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                xData.push(moment(v['YMDH']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeEps == 0 ? calc.voltage(v['VAC1EPS'], protocol) :
                    activeEps == 1 ? calc.frequency(v['FACEPS'], protocol) :
                        activeEps == 2 ? calc.power(v['PAC1EPS'], protocol) :
                            activeEps == 3 ? Math.round(calc.voltage(v['VAC1EPS'], protocol) * calc.current(v['IAC1EPS'], protocol)) :
                                null)
            })
            //x轴坐标
            epsOption.xAxis.data = xData;
            //数据
            epsOption.series[0] =
                activeEps == 0 ? { ...epsOption.series[0], name: t('Vepsr'), data: yData } :
                    activeEps == 1 ? { ...epsOption.series[0], name: t('Feps'), data: yData } :
                        activeEps == 2 ? { ...epsOption.series[0], name: t('Peps'), data: yData } :
                            activeEps == 3 ? { ...epsOption.series[0], name: t('Seps'), data: yData } :
                                null
        }

        const instance = epsChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(epsOption, true);
        }
    }, [invData, activeEps, t])

    return (
        <div className="runtime-parameter">
            <div className="runtime-parameter-header">
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t('Enter Inverter Name')}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px' }}
                >{inverterSelectOptions}</Select>
                <DatePicker
                    defaultValue={moment()}
                    value={moment(parameterDate)}
                    onChange={(_, ds) => setParameterDate(ds)}
                    allowClear={false}
                />
            </div>
            <div className="runtime-parameter-main">
                <div className="side side-left">
                    <div className="title">{t('PV Side')}</div>
                    <div className="item">
                        <ul>
                            <li className={activePV == 0 ? 'active' : null} onClick={() => {
                                setActivePV(0)
                                setPVTitle(t('Vpv1(V)'))
                            }}>{t('Vpv1(V)')}</li>
                            <li className={activePV == 1 ? 'active' : null} style={{ display: protocol === 'Senergy' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(1)
                                setPVTitle(t('Vpv2(V)'))
                            }}>{t('Vpv2(V)')}</li>
                            <li className={activePV == 2 ? 'active' : null} style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(2)
                                setPVTitle(t('Vpv3(V)'))
                            }}>{t('Vpv3(V)')}</li>
                            <li className={activePV == 3 ? 'active' : null} style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(3)
                                setPVTitle(t('Vpv4(V)'))
                            }}>{t('Vpv4(V)')}</li>
                            <li className={activePV == 4 ? 'active' : null} onClick={() => {
                                setActivePV(4)
                                setPVTitle(t('Ppv1(W)'))
                            }}>{t('Ppv1(W)')}</li>
                            <li className={activePV == 5 ? 'active' : null} style={{ display: protocol === 'Senergy' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(5)
                                setPVTitle(t('Ppv2(W)'))
                            }}>{t('Ppv2(W)')}</li>
                            <li className={activePV == 6 ? 'active' : null} style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(6)
                                setPVTitle(t('Ppv3(W)'))
                            }}>{t('Ppv3(W)')}</li>
                            <li className={activePV == 7 ? 'active' : null} style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }} onClick={() => {
                                setActivePV(7)
                                setPVTitle(t('Ppv4(W)'))
                            }}>{t('Ppv4(W)')}</li>

                        </ul>
                    </div>
                </div>
                <div className="box box-left">
                    <div className="title">
                        {t(PVTitle)} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={pvChart} option={pvOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div className="side side-right">
                    <div className="title">{t('Battery')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeBat == 0 ? 'active' : null} onClick={() => {
                                setActiveBat(0)
                                setBatTitle(t('SOC(%)'))
                            }}>{t('SOC(%)')}</li>
                            <li className={activeBat == 1 ? 'active' : null} onClick={() => {
                                setActiveBat(1)
                                setBatTitle(t('vBat(V)'))
                            }}>{t('VBat(V)')}</li>
                            <li className={activeBat == 2 ? 'active' : null} onClick={() => {
                                setActiveBat(2)
                                setBatTitle(t('IBat(A)'))
                            }}>{t('IBat(A)')}</li>
                            <li className={activeBat == 3 ? 'active' : null} onClick={() => {
                                setActiveBat(3)
                                setBatTitle(t('Charge Power(W)'))
                            }}>{t('Charge Power(W)')}</li>
                            <li className={activeBat == 4 ? 'active' : null} onClick={() => {
                                setActiveBat(4)
                                setBatTitle(t('DisCharge Power(W)'))
                            }}>{t('DisCharge Power(W)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box">
                    <div className="title">
                        {t(BatTitle)} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={batChart} option={batOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div style={{ clear: 'both' }}></div>
                <div className="side side-left">
                    <div className="title">{t('AC Side')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeAC == 0 ? 'active' : null} onClick={() => {
                                setActiveAC(0)
                                setACTitle(t('Vacr(V)'))
                            }}>{t('Vacr(V)')}</li>
                            <li className={activeAC == 1 ? 'active' : null} onClick={() => {
                                setActiveAC(1)
                                setACTitle(t('Qac(Var)'))
                            }}>{t('Qac(Var)')}</li>
                            <li className={activeAC == 2 ? 'active' : null} onClick={() => {
                                setActiveAC(2)
                                setACTitle(t('pToGrid(W)'))
                            }}>{t('pToGrid(W)')}</li>
                            <li className={activeAC == 3 ? 'active' : null} onClick={() => {
                                setActiveAC(3)
                                setACTitle(t('pFromGrid(W)'))
                            }}>{t('pFromGrid(W)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box box-left">
                    <div className="title">
                        {t(ACTitle)} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={acChart} option={acOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div className="side side-right">
                    <div className="title">{t('Backup')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeEps == 0 ? 'active' : null} onClick={() => {
                                setActiveEps(0)
                                setEpsTitle(t('Vepsr(V)'))
                            }}>{t('Vepsr(V)')}</li>
                            <li className={activeEps == 1 ? 'active' : null} onClick={() => {
                                setActiveEps(1)
                                setEpsTitle(t('Feps(Hz)'))
                            }}>{t('Feps(Hz)')}</li>
                            <li className={activeEps == 2 ? 'active' : null} onClick={() => {
                                setActiveEps(2)
                                setEpsTitle(t('Peps(W)'))
                            }}>{t('Peps(W)')}</li>
                            <li className={activeEps == 3 ? 'active' : null} onClick={() => {
                                setActiveEps(3)
                                setEpsTitle(t('Seps(VA)'))
                            }}>{t('Seps(VA)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box">
                    <div className="title">
                        {t(EpsTitle)} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={epsChart} option={epsOption} style={{ height: 280 }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RuntimeParameter;